import { type QueryOptions } from '@tanstack/query-core'

import { type AdditionalPaymentCategoryEntity } from '@/libs/api'
import type { ReportType } from '@/libs/api/types'

import { fetchAdditionalPaymentCategories } from '../api'
import { additionalPaymentCategoriesQueryKeys } from '../query-keys'

/**
 * Select用の追加支払種別一覧のQueryOptionsを返す
 */
export const getAdditionalPaymentCategoriesSelectQueryOptions = (
  tenantKey: string,
  reportType: ReportType
): Required<
  Pick<QueryOptions<AdditionalPaymentCategoryEntity[]>, 'queryKey' | 'queryFn'>
> => {
  return {
    queryKey: additionalPaymentCategoriesQueryKeys.select(tenantKey),
    queryFn: async ({ signal }) => {
      const { data } = await fetchAdditionalPaymentCategories(
        {
          tenantKey,
          reportType
        },
        signal
      )
      return data
    }
  }
}
